import React from "react";
import { motion } from "framer-motion"; // Import Framer Motion
import bgImage from "../assets/about1.png"; // Ensure correct import path
import md from "../assets/Director/MDBG.png";

const About = () => {
  return (
    <div className="mt-[3%]">
      <div>
        <h2 className="text-6xl font-serif font-bold tracking-wide  text-center">
          About Us
        </h2>
      </div>
      <div
        className="relative bg-cover bg-center flex items-center justify-center py-[5%] w-full"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div></div>
        {/* Semi-transparent Overlay */}
        <div className="absolute inset-0 bg-white bg-opacity-60"></div>

        <div className="relative max-w-7xl w-full  rounded-lg flex flex-col lg:flex-row items-center">
          {/* Left Section */}
          <div className="flex text-left flex-col lg:flex-row">
            {/* Heading with Animation */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.3 }}
              viewport={{ once: true }}
              className="flex justify-center items-center" // Add flexbox to center content
            >
              <h2 className="tracking-wide mb-6 text-center">
                <img src={md} className="rounded-[5px]" />
                <div className="text-center mt-5">
                  <p className="text-[16px] font-semibold">HEMA RAM REDDY</p>
                  <p className="text-[12px] font-semibold">MANAGING DIRECTOR</p>
                </div>
              </h2>
            </motion.div>

            {/* Text Section with Animation */}
            <motion.div
              className="ml-[5%] lg:w-[70%] mr-[5%]"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.6 }} // Slightly later than heading
              viewport={{ once: true }} // Trigger animation once when in view
            >
              <p className="text-gray-800 leading-relaxed text-lg">
                At Siddhi Ganapathi Developers, we are committed to creating
                high-value real estate opportunities that promise security,
                growth, and long-term returns. With over a decade of experience
                in the industry, we have earned a reputation for delivering
                legally approved, strategically located, and future-ready
                developments that investors and homeowners can trust.
              </p>
              <p className="text-gray-800 leading-relaxed text-lg mt-4">
                Built on a foundation of transparency, integrity, and customer
                satisfaction, our projects are designed to offer not just
                property ownership but a secure and prosperous future. Whether
                you're looking for a residential plot or a smart investment,
                Siddi Ganapathi Developers is your trusted partner in real
                estate success.
              </p>

              <p className="font-serif text-gray-800  text-[24px] mt-4 w-[100%] text-center">
                “Your vision, our foundation.”
              </p>

              {/* Read More Button */}
              {/* <motion.button
              className="mt-6 px-6 py-3 border border-black text-black text-lg font-medium transition hover:bg-black hover:text-white mt-[15%]"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.9 }} // Button appears last
              viewport={{ once: true }} // Trigger animation once when in view
            >
              READ MORE
            </motion.button> */}
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
